import '../../App_Assets/scss/productresults.scss';
import '../components/common/page';
import '../components/title_text_seo/title-text-seo';

import '../../App_Assets/scss/v2/pr-standart.scss';
import '../components/tracking_third_party/tiktokWishlist';
import '../components/v2/Prp';

$(function () {
    //Scroll to the opened one
    $('.csTopLevelContainer.singleOpenable-prp').on('shown.bs.collapse', function (e) {
        //var offset = $('.csTopLevelContainer .in').offset().top - 45 ;
        let offset = $(e.target).offset().top - 45;
        if ($(window).width() < 992 && $(window).width() >= 768) {
            //Tablet
            offset -= 22;
        }

        if ($(window).width() < 768) {
            //Mobile
            offset -= 125;
        }
        $('html, body').animate({ scrollTop: offset + 'px' });
    });
});
